import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  NumberField,
  ImageField,
  Filter,
  SelectInput,
  BooleanField,
  EditButton
} from 'react-admin';
import { DateInput } from 'react-admin-date-inputs';

const types = [
  { id: 'politician', name: 'Politician' },
  { id: 'celebrity', name: 'Celebrity' },
  { id: 'event', name: 'Event' },
];

const defaultDate = new Date(+new Date() - 7 * 24 * 60 * 60 * 1000);

const TopicStatsFilter = props => (
  <Filter {...props}>
    <DateInput label="From Date" source="from" options={{ format: 'dd.MM.yyyy', clearable: true }} alwaysOn />
    <DateInput label="To Date" source="to" options={{ format: 'dd.MM.yyyy', clearable: true }} alwaysOn />
    <TextInput label="Search" source="q" alwaysOn />
    <SelectInput source="topic_type" choices={types} alwaysOn />
  </Filter>
);

export const TopicStatsList = props => (
  <List title="Topics" {...props} filters={<TopicStatsFilter />} filterDefaultValues={{ from: defaultDate }} bulkActionButtons={false} >
    <Datagrid>
      <ImageField source="thumbnail" sortable={false} />
      <TextField source="name" />
      <NumberField source="articles" />
      <NumberField source="likes" />
      <NumberField source="shares" />
      <NumberField source="comments" />
      <NumberField label="FB total" source="total" />
      <NumberField source="score" />
      <BooleanField source="active" />
      <EditButton resource="topics" basePath="/topics" label="" />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/resources/topicsstats.js